import React from 'react';
import { observer } from 'mobx-react';
import { WordOptionsCardWrapper, ExampleSentenceTranslationProvider } from '@seedlang/hoc';
import styled from '@emotion/styled';
import MediaSection from 'components/vocab_card/media_section';
import CardSection from 'components/vocab_card/card_section';
import ExpandedTarget from 'components/vocab_card/expanded_target';
import ExampleSentence, { ExampleSentenceToggle } from 'components/vocab_card/example_sentence';
import { DeckUI, OverlayUI } from '@seedlang/state';
import CardWrapper from 'components/layout/card_wrapper';
import CardContent from 'components/layout/card_content';
import MultipleChoiceButtons from 'components/card/multiple_choice_buttons';
import EvaluateButtons from 'components/card/evaluate_buttons';
import CardSourceList from 'components/vocab_card/card_source_list';
import { pixify } from '@seedlang/utils';

const ExampleSentenceWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const SourceText = styled.span`
  cursor: pointer;
`;

@observer
class WordOptionsCard extends React.Component {
  onClickTargetSection = () => {
    DeckUI.openDeckVocabCard({
      card: this.props.card,
      cardState: this.props.cardState,
      requiresRevealed: true,
    });
  }

  openSourceEdit = () => {
    DeckUI.createEvent('deck - click translations icon', {
      language_id: this.props.card?.languageId || DeckUI.deck?.languageId,
      card_type_id: this.props.card?.cardType?.id || this.props.card?.cardTypeId,
    });
    OverlayUI.addOverlay('sourceEdit');
  }

  render() {
    return (
      <CardWrapper
        card={this.props.card}
        cardState={this.props.cardState}
        userCard={this.props.userCard}
        icons={this.props.icons}
      >
        <CardContent
          height={pixify(this.props.cardState.revealed ? DeckUI.layout.contentHeight : DeckUI.layout.contentHeightWithMultipleChoiceButtons(4))}
        >
          {
            this.props.card.hasTargetVideoClip &&
              <MediaSection
                showMedia
                card={this.props.card}
                cardState={this.props.cardState}
                autoPlay={this.props.inView}
                borderTopRadius={10}
                height={this.props.mediaSectionHeight}
              />
          }
          <CardSection
            background='#FFF'
            borderTopRadius={this.props.card.hasTargetVideoClip ? 0 : 10}
            borderBottomRadius={this.props.cardState.revealed ? 0 : 10}
            height={this.props.sectionHeight}
            onClick={this.props.showExpandedTarget && DeckUI.canOpenDeckVocabCard(this.props.card, this.props.cardState, true) ? this.onClickTargetSection : null}
          >
            {
              this.props.showExpandedTarget &&
                <ExpandedTarget
                  card={this.props.card}
                  cardState={this.props.cardState}
                  height={this.props.sectionHeight}
                  word={this.props.card.word}
                  sentenceHintShown={this.props.sentenceHintShown}
                  showSentenceHint={this.props.showSentenceHint}
                />
            }
            {Boolean(!this.props.showExpandedTarget && this.props.hasExampleSentence) &&
              <ExampleSentenceTranslationProvider
                parts={this.props.card.word.cardExampleSentence}
                translation={this.props.card.word.cardExampleTranslation}
                languageId={this.props.card.word.languageId}
                revealed={this.props.cardState.revealed}
                visible={this.props.showExampleSentence}
              >
                <ExampleSentenceWrapper>
                  <ExampleSentenceToggle inset={-5} showHint={this.props.showSentenceHintButton} onShowHint={this.props.showSentenceHint} />
                  {this.props.showExampleSentence &&
                    <ExampleSentence
                      key={this.props.card.id}
                      parts={this.props.card.word.cardExampleSentence}
                      translation={this.props.card.word.cardExampleTranslation}
                      revealed={this.props.cardState.revealed}
                      fontSize={DeckUI.layout.minimumHeight ? 13 : 14}
                      color='#333'
                    />
                  }
                </ExampleSentenceWrapper>
              </ExampleSentenceTranslationProvider>
            }
          </CardSection>
          {
            this.props.cardState.revealed &&
              <CardSection
                background='#CCC'
                borderBottomRadius={10}
                height={this.props.sectionHeight}
                fontSize={(this.props.card.word.isNumber && this.props.card.word.digitSourceText) ? '34px' : null}
          >
                {
                  (!this.props.card.word.isNumber || !this.props.card.word.digitSourceText) &&
                    <CardSourceList
                      showEdit
                      word={this.props.card.word}
                      card={this.props.card}
                    />
                }
                {
                  this.props.card.word.isNumber && this.props.card.word.digitSourceText &&
                    <SourceText
                      onClick={this.openSourceEdit}
                    >
                      {this.props.card.word.formattedDigitSourceText}
                    </SourceText>
                }

              </CardSection>
          }
        </CardContent>
        {
          !this.props.cardState.revealed &&
            <MultipleChoiceButtons
              disabled={!this.props.inView}
              height={DeckUI.layout.totalMultipleChoiceButtonHeight(4)}
              buttonHeight={DeckUI.layout.multipleChoiceButtonHeight}
              width={DeckUI.layout.innerDeckWidth}
              options={this.props.multipleChoiceOptions}
              onClick={option => this.props.onClick(option)}
              selected={[this.props.multipleChoiceSelected]}
              isMobile={DeckUI.layout.isMobile}
              correct={this.props.correct}
              field='text'
              languageId={this.props.card.languageId}
            />
        }
        {
          this.props.cardState.revealed &&
            <EvaluateButtons
              card={this.props.card}
              onNextClick={this.props.onNextClick}
              cardState={this.props.cardState}
              userCard={this.props.userCard}
              disabled={!this.props.inView}
            />
        }
      </CardWrapper>
    );
  }
}

export default WordOptionsCardWrapper(WordOptionsCard);
